/**
 * 获取top window的标题
 */
export default (isTop = false): string => {
  let title = '';
  try {
    const win = isTop ? window.top : window;
    title = win.document.title || win.document.querySelector('title')?.innerText;
  } catch (error) {
    title = window.document.title || window.document.querySelector('title')?.innerText;
  }
  return (title || '未知页面').trim();
}
